/**
 * ÐÐ°ÑÐ¸Ð½Ð° Ð¸Ð· ÑÑÐ¶Ð¾Ð³Ð¾ Ð³Ð¾ÑÐ¾Ð´Ð°.
 *
 * Ð¡ÑÐ¾Ðº Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¸Ð´Ð¸Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ ÑÐ²Ð¾Ð¸Ð¼ Ð³Ð¾ÑÐ¾Ð´Ð°Ð¼, Ð½Ð¾ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð¿Ð¾Ð»Ð½Ð¾Ð¼Ñ VIN
 * Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ Ð¼Ð°ÑÐ¸Ð½Ñ Ð¾ÑÐºÑÐ´Ð° ÑÐ³Ð¾Ð´Ð½Ð¾ â Ð¸Ð½Ð°ÑÐµ ÐµÑ Ð½Ðµ Ð¿ÐµÑÐµÐ½ÐµÑÑÐ¸ Ðº ÑÐµÐ±Ðµ. Ð Ð°Ð· Ð¼Ð°ÑÐ¸Ð½Ð°
 * Ð½Ð°ÑÐ»Ð°ÑÑ, Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿Ð¾ Ð¿ÑÐ¸Ð²ÑÑÐºÐµ ÑÑÐ¸ÑÐ°ÐµÑ ÐµÑ ÑÐ²Ð¾ÐµÐ¹, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð³Ð¾ÑÐ¾Ð´ Ñ ÑÐ°ÐºÐ¸Ñ Ð¼Ð°ÑÐ¸Ð½
 * Ð¿Ð¾Ð¼ÐµÑÐ°ÐµÐ¼ (24.10.2026, Ð¿ÑÐ¾ÑÑÐ±Ð° Ð¿ÐµÑÐµÐ½ÐµÑÑÐ¸ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² Ð¢Ð°ÑÐ°Ð·).
 *
 * ÐÐ¾ÑÐ¾Ð´Ð° Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð² Ð¿ÑÐ¾ÑÐ¸Ð»Ðµ (`user.cities`) ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ Ð²Ð¸Ð´Ð° [{ cityId }].
 * ÐÑÑÑÐ¾Ð¹ ÑÐ¿Ð¸ÑÐ¾Ðº â Ñ ÑÐ¾ÑÑÑÐ´Ð½Ð¸ÐºÐ° Ð½ÐµÑ Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¸Ñ Ð¿Ð¾ Ð³Ð¾ÑÐ¾Ð´Ð°Ð¼ (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ, Ð°Ð´Ð¼Ð¸Ð½):
 * ÑÐ¾Ð³Ð´Ð° ÑÑÐ¶Ð¸Ñ Ð¼Ð°ÑÐ¸Ð½ Ð´Ð»Ñ Ð½ÐµÐ³Ð¾ Ð½Ðµ Ð±ÑÐ²Ð°ÐµÑ.
 */
export function isForeignCityCar(carCityId, userCities) {
  if (!carCityId) return false;
  if (!Array.isArray(userCities) || userCities.length === 0) return false;

  return !userCities.some((item) => Number(item?.cityId ?? item?.id ?? item) === Number(carCityId));
}

export default isForeignCityCar;
